// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  FileUploadMethod: 0,
   //appUrl: 'http://localhost:1009/api/',
   appUrl: 'http://223.30.223.183/api/',
  paymentGatewayUrl: 'http://formbuilder-pg-staging.3.6.121.201.nip.io/',
  apiKeyForPhoto:'scannedPhotographOfTheCandidate',
  apiKeyForSign:'scannedSignatureOfTheCandidate',
  pageIndexForPhotoSign:2,
  apiForPhotoValidation:"http://15.207.247.176:5000/photo_updated",
  apiForSignValidation:"http://15.207.247.176:5000/sign_updated",
  stateListForTwoSlice:"['andhraPradesh','arunachalPradesh','andamanNicobar','assam','bihar','chandigarh','chhattisgarh','delhi','goa','gujarat','haryana','himachalPradesh','jammuKashmir','jharkhand','karnataka','kerala','lakshadweep','madhyaPradesh','maharashtra','nagaland','odisha','puducherry','punjab','rajasthan','sikkim','tamilNadu','uttarakhand','uttarPradesh','westBengal']",
  stateListForThreeSlice:"['manipur','mizoram','tripura']",
  andhraPradeshList:"[50,51,52,53]",
  arunachalPradeshList:"[79]",
  assamList:"[78]",
  biharList:"[80,81,82,83,84,85]",
  chandigarhList:"[49]",
  delhiList:"[11]",
  goaList:"[40]",
  gujaratList:"[36,37,38,39]",
  haryanaList:"[12,13]",
  himachalPradeshList:"[17]",
  jammuKashmirList:"[18,19]",
  jharkhandList:"[80,81,82,83,84,85,93]",
  karnatakaList:"[56,57,58,59]",
  keralaList:"[67,68,69]",
  madhyaPradeshList:"[45,46,47,48]",
  maharashtraList:"[40,41,42,43,44]",
  manipurList:"[795]",
  mizoramList:"[796]",
  nagalandList:"[79]",
  odishaList:"[75,76,77]",
  puducherryList:"[60,67,53]",
  punjabList:"[14,15,16]",
  rajasthanList:"[30,31,32,33,34]",
  sikkimList:"[73]",
  tamilNaduList:"[60,61,62,63,64]",
  tripuraList:"[799]",
  uttarPradeshList:"[20,21,22,23,24,25,26,27,28]",
  uttarakhandList:"[20,21,22,23,24,25,26,27,28]",
  meghalayaList:"[793,794,783123]",
  westBengalList:"[70,71,72,73,74,744]"
};
